<ng-container *ngIf="!useFieldSet; else fieldSet">
  <label [for]="controlName">
    <div
      *ngIf="label && label.length > 0"
      class="iris-form-field-label"
      [ngClass]="{'accommodate-helper-text': helperText}"
    >
      <span
        class="iris-form-field-label-text"
        [ngClass]="{'invalid': irisFormFieldControl?.control?.touched
          | isControlInvalidAndTouched:irisFormFieldControl?.control?.invalid
        }"
      >
        {{ label }}
      </span>        
      <span
        *ngIf="!(irisFormFieldControl?.control | isControlRequired) && showOptionalTag"
        class="iris-form-field-label-optional"
      >
        (optional)
      </span>
    </div>

    <p *ngIf="helperText" class="iris-form-field-helper-text">{{ helperText }}</p>

    <ng-content select=".iris-help-info"></ng-content>

    <ng-content select="iris-text-input"></ng-content>
    <ng-content select="iris-text-area"></ng-content>

    <ng-container *ngTemplateOutlet="hint"></ng-container>
  </label>
</ng-container>

<!-- Use this if it's a radio-group, checkbox(es), or dropdown(s) -->
<ng-template #fieldSet>
  <fieldset>
    <legend class="iris-form-field-label" [ngClass]="{'accommodate-helper-text': helperText}">
      <span 
        class="iris-form-field-label-text" 
        [ngClass]="{
          'invalid': (irisFormFieldControl?.control?.touched | isFormFieldInvalidAndTouched
            :irisFormFieldControl?.control?.invalid
            :multiCheckboxSubForm?.touched
            :multiCheckboxSubForm?.invalid
        )}"
      >
        {{ label }}
      </span>
      <span
        *ngIf="!(multiCheckboxSubForm | isFormFieldRequired: irisFormFieldControl?.control) && showOptionalTag"
        class="iris-form-field-label-optional"
      >
        (optional)
      </span>
    </legend>

    <p *ngIf="helperText" class="iris-form-field-helper-text">{{ helperText }}</p>

    <ng-content></ng-content>

    <ng-container *ngTemplateOutlet="hint"></ng-container>
  </fieldset>
</ng-template>

<ng-template #hint>
  <ng-container *ngIf="!(irisFormFieldControl?.control?.touched | isFormFieldInvalidAndTouched
    :irisFormFieldControl?.control?.invalid
    :multiCheckboxSubForm?.touched
    :multiCheckboxSubForm?.invalid)">
    <ng-content select="iris-hint"></ng-content>
  </ng-container>
</ng-template>

<div 
  class="iris-form-field-error-messages"
  [attr.id]="controlName ? controlName + '-error-messages' : null"
  *ngIf="(irisFormFieldControl?.control?.touched | isFormFieldInvalidAndTouched
    :irisFormFieldControl?.control?.invalid
    :multiCheckboxSubForm?.touched
    :multiCheckboxSubForm?.invalid
  )"
>
  <div 
    *ngFor="let errorMessage of errorMessagesToDisplay" 
    aria-live="assertive"
    class="iris-form-field-error-message"
  >
    {{ errorMessage }}
  </div>
</div>
